import {ORGANIZATION_SERVER} from "@/api";
import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";

const roleHierarchy = new RestResource({server: ORGANIZATION_SERVER, resource: 'roleHierarchy'});

roleHierarchy.changeParent = (id, currentRole) => {
    let url = `${ORGANIZATION_SERVER}/roleHierarchy/changeParent/${id}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, currentRole).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

roleHierarchy.extendRolePage = function selectExtendRolePage(roleId, params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/roleHierarchy/extendRole/page/${roleId}`, params)
            .then(result => {
                result.status === 200 ? resolve(result) : reject(result)
            }, (error) => {
                reject(error);
            })
    })
}

export default roleHierarchy;